function getErrorMessage(statusCode: number): { title: string; message: string } {
  const { t } = useI18n();
  switch (statusCode) {
    case 403:
      return {
        title: t('errors.403.title'),
        message: t('errors.403.message')
      };
    case 404:
      return {
        title: t('errors.404.title'),
        message: t('errors.404.message')
      };
    case 500:
      return {
        title: t('errors.500.title'),
        message: t('errors.500.message')
      };
    default:
      return {
        title: t('errors.default.title'),
        message: t('errors.default.message')
      };
  }
}

export { getErrorMessage };
